import React, { useState, useEffect } from "react";
import { AnnsModal, Col } from "../Component";
import { Form } from "reactstrap";
import { Storage } from "../../services/storage/storage";

const ImageViewModal = ({ visible, url, onClosed, title = "View Screenshot" }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(null);

  const close = () => {
    onClosed();
    setImageError(false);
    setImageLoading(true);
    setImageSrc(null);
  };

  useEffect(() => {
    if (visible && url) {
      setImageError(false);
      setImageLoading(true);
      setImageSrc(null);
      loadImage();
    }
  }, [visible, url]);

  const loadImage = async () => {
    if (!url) {
      setImageLoading(false);
      return;
    }

    try {
      // Construct the full image URL
      let fullImageUrl = url;
      
      // If URL doesn't start with http/https, prepend base URL
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        const baseUrl = process.env.REACT_APP_API_PATH || "";
        const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
        const cleanUrl = url.startsWith("/") ? url : `/${url}`;
        fullImageUrl = `${cleanBaseUrl}${cleanUrl}`;
      }

      console.log("fullImageUrl", fullImageUrl);

      // Try to load image with authentication headers
      const token = Storage.getUserToken();
      if (token && fullImageUrl.includes(process.env.REACT_APP_API_PATH)) {
        try {
          const response = await fetch(fullImageUrl, {
            method: "GET",
            headers: {
              "X-Session-Key": token,
              "X-API-Key": process.env.REACT_APP_API_KEY || "",
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);
            setImageSrc(objectUrl);
            setImageLoading(false);
            setImageError(false);
            return;
          }
        } catch (fetchError) {
          console.warn("Failed to load image with auth headers, trying direct URL:", fetchError);
        }
      }

      // Fallback to direct URL
      setImageSrc(fullImageUrl);
      setImageLoading(false);
    } catch (error) {
      console.error("Error loading image:", error);
      setImageError(true);
      setImageLoading(false);
    }
  };

  // Cleanup blob URL on unmount
  useEffect(() => {
    return () => {
      if (imageSrc && imageSrc.startsWith("blob:")) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [imageSrc]);

  return (
    <AnnsModal size={"xl"} isOpen={visible} toggle={close} title={title} isFooterHide>
      <Form className="row gy-4 form-validation">
        <Col md="12">
          <div
            style={{
              border: "1px solid rgba(0, 0, 0, 0.1)",
              minHeight: "500px",
              maxHeight: "750px",
              width: "100%",
              overflow: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f8f9fa",
            }}
          >
            {imageLoading && (
              <div style={{ color: "#999", fontSize: "16px" }}>Loading image...</div>
            )}
            {url && !imageError && imageSrc ? (
              <img
                src={imageSrc}
                alt="Screenshot"
                style={{
                  maxWidth: "100%",
                  maxHeight: "750px",
                  objectFit: "contain",
                  display: imageLoading ? "none" : "block",
                }}
                onLoad={() => {
                  setImageLoading(false);
                  setImageError(false);
                }}
                onError={(e) => {
                  setImageLoading(false);
                  setImageError(true);
                  console.error("Error loading image:", imageSrc);
                }}
              />
            ) : imageError ? (
              <div style={{ color: "#999", fontSize: "16px", textAlign: "center" }}>
                <div>Image not available</div>
                <div style={{ fontSize: "12px", marginTop: "10px", color: "#666" }}>
                  {url || "N/A"}
                </div>
              </div>
            ) : !url ? (
              <div style={{ color: "#999", fontSize: "16px" }}>No image available</div>
            ) : null}
          </div>
        </Col>
      </Form>
    </AnnsModal>
  );
};

export default ImageViewModal;
